module.exports = __webpack_public_path__ + "img/6c4a7d4.png";